import React from "react";
import "./index.css";
import Button from "../Button";
import { motion } from "framer-motion";

const CTAsec = ({ href, type, variants }) => {
  return null;
  /* 
  return (
    <div className="ctaSec section colorSec">
      <div className="container-lg flex flexRow alignCenter justifySpace flexWrap">
        <motion.h3
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.3}
        >
          Aplicá nuestros algoritmos de Machine Learning para resolver problemas
          de negocio
        </motion.h3>
        <Button
          text={"Aplicá ahora"}
          href={href}
          color={"whiteAll"}
          type={type}
          variants={variants}
          delay={0.6}
        />
      </div>
    </div>
  );
  */
};

export default CTAsec;
